/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { useToggle } from '@hooks/useToggle';

interface NameCellProps {
  isInGroup: boolean;
  row: any;
  rowDetail: React.ReactNode;
}

export const NameCell = ({ isInGroup, row, rowDetail }: NameCellProps) => {
  const [isOpen, toggleOpen] = useToggle(false);

  return (
    <div className='name-container' onClick={toggleOpen}>
      <div className={`text-truncate ${isInGroup ? '' : 'text-ThemeTextDark'}`}>
        <i className={`fa ${isOpen ? 'fa-caret-down' : 'fa-caret-right'} mr-2`} />
        {row.original.name}
      </div>
      <div className={`name-container-details ${!isOpen ? 'd-none' : 'd-flex'} pb-3 border-bottom`}>
        <div><i className={'fa fa-blank mr-2'} /></div>
        <div>
          {rowDetail}
        </div>
      </div>
    </div>
  );
};
